import { ChefHat } from "lucide-react";
import { cn } from "@/lib/utils";
import type { HelpCategoryId } from "@/types/help";
import { CategoryPill } from "./category-meta";

/**
 * Article hero/thumbnail. Until a real image pipeline exists, missing images
 * render a neutral placeholder. When a `category` is passed, its pill is
 * anchored to the bottom-left (matching the Figma cards).
 */
export function ArticleThumb({
  category,
  imageUrl,
  className,
}: {
  category?: HelpCategoryId;
  imageUrl?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "relative flex items-end overflow-hidden rounded-lg border border-(--shell-border) bg-(--gray-200) p-3",
        className,
      )}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          className="pointer-events-none absolute inset-0 size-full object-cover"
        />
      ) : (
        <ChefHat className="absolute right-3 top-3 size-8 text-(--gray-300)" />
      )}
      {category && <CategoryPill category={category} className="relative" />}
    </div>
  );
}
